import { ButtonHTMLAttributes } from "react";

import { ButtonContainer } from "./styles";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export function SecondaryButton(props: ButtonProps) {
  return <ButtonContainer type="button" className="button" {...props} />;
}
